interface Props {
  className?: string;
}

export default function BunkBedIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0L1 29" stroke="currentColor" strokeWidth={2} />
      <line
        x1={27.946}
        y1={-0.00175371}
        x2={28}
        y2={28.9981}
        stroke="currentColor"
        strokeWidth={2}
      />
      <line
        x1={1}
        y1={7}
        x2={27}
        y2={7}
        stroke="currentColor"
        strokeWidth={2}
      />
      <line
        x1={1}
        y1={11}
        x2={27}
        y2={11}
        stroke="currentColor"
        strokeWidth={2}
      />
      <line
        x1={1}
        y1={22}
        x2={27}
        y2={22}
        stroke="currentColor"
        strokeWidth={2}
      />
      <line
        x1={1}
        y1={26}
        x2={27}
        y2={26}
        stroke="currentColor"
        strokeWidth={2}
      />
      <path d="M2 3H6L8.4 3.8L10 7" stroke="currentColor" strokeWidth={2} />
      <path d="M2 18H6L8.4 18.8L10 22" stroke="currentColor" strokeWidth={2} />
    </svg>
  );
}
